<template>
  <div class="service-support-page">

    <!-- 搜索弹窗 -->
    <div class="search" v-show="searchVisible">
      <div class="sc_bj">
        <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
          <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- 页面Banner -->
    <div class="ny_ban" style="background-image:url(/images/n_ban3.jpg);">
      <div class="container">
        <h1 class="wow fadeInLeft" data-wow-delay=".5s">Service & Support</h1>
      </div>
    </div>

    <!-- 选择我们的理由 -->
    <div class="fw_js">
      <div class="container">
        <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
          <h1>Why Choose Us</h1>
        </div>
        <ul class="row wow fadeInUp" data-wow-delay=".5s">
          <li v-for="(item, index) in chooseUsList" :key="index">
            <div class="t_b" :style="{ backgroundImage: `url(/images/${item.icon})` }"></div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 服务流程 -->
    <div class="fw_lc">
      <div class="container">
        <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
          <h1>Full-case Service Process</h1>
        </div>
        <div class="lc_zs wow fadeInUp" data-wow-delay=".5s">
          <div class="swiper-container swiper-lc">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in serviceProcessList" :key="index">
                <div class="s_z">{{ index + 1 }}</div>
                <div class="l_m" :style="{ backgroundImage: `url(/images/${item.bgImage})` }">
                  <img :src="`/images/${item.icon}`">
                  <h1 v-html="item.title"></h1>
                </div>
                <div class="w_z">{{ item.desc }}</div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev" @click="serviceProcessSwiper.slidePrev()"><i
              class="iconfont icon-youjiantou"></i></div>
          <div class="swiper-button-next" @click="serviceProcessSwiper.slideNext()"><i
              class="iconfont icon-zuojiantou"></i></div>
        </div>
        <div class="fw_xx wow fadeInUp" data-wow-delay=".5s">
          <h3>If you have any technical or maintenance-related questions, you can choose one of the following ways to
            contact us:</h3>
          <div class="row">
            <div class="xx_nr" v-for="(item, index) in contactInfoList" :key="index">
              <div class="t_b"><img :src="`/images/${item.icon}`"></div>
              <div class="w_z">
                <h4>{{ item.title }}</h4>
                <strong :class="{ y_x: item.isEmail }">{{ item.value }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频展示 -->
    <!-- <div class="fw_sp">
      <div class="container">
        <div class="sp_bt">Production Line Video Display</div>
        <div class="sp_zs wow fadeInUp" data-wow-delay=".5s">
          <div class="swiper-container swiper-sp">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in videoList" :key="index">
                <a href="javascript:;" @click.stop>
                  <div class="t_p">
                    <img :src="`/images/${item.cover}`">
                    <i @click="openVideoModal(item.videoUrl)">
                      <img src="/images/sp.png">
                    </i>
                  </div>
                  <div class="w_z">
                    <span>{{ item.category }}</span>
                    <h3>{{ item.title }}</h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev" @click="videoSwiper.slidePrev()"><i class="iconfont icon-youjiantou"></i></div>
          <div class="swiper-button-next" @click="videoSwiper.slideNext()"><i class="iconfont icon-zuojiantou"></i></div>
        </div>
      </div>
    </div> -->

    <div class="fw_sp">
      <div class="container">
        <div class="sp_bt">Project Case</div>
        <div class="sp_zs wow fadeInUp" data-wow-delay=".5s">
          <div class="swiper-container swiper-sp" ref="videoSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in articlesData" :key="index">
                <a :href="`/case_details/${item.id}`">
                  <div class="t_p">
                    <img :src="`https://cdn.bosscaigou.com/${item?.himg}`" alt="Pig slaughter line">
                    <!-- <i><img src="/images/sp.png" alt="play"></i> -->
                  </div>
                  <div class="w_z">
                    <!-- <span>{{ item?.articleType?.value || 'ALL' }}</span> -->
                    <h3
                      style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;">
                      {{ item?.title || 'No Title' }}</h3>
                  </div>
                </a>
              </div>
              <!-- <div class="swiper-slide">
                                <a href="javascript:;"
                                    @click.stop="openZsVideo('https://cdn.bosscaigou.com/video_xc.mp4')">
                                    <div class="t_p">
                                        <img src="/images/sp2.jpg" alt="Pig slaughter line">
                                        <i><img src="/images/sp.png" alt="play"></i>
                                    </div>
                                    <div class="w_z">
                                        <span>Pig slaughter line</span>
                                        <h3>Video of Pig Slaughtering Production Line</h3>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="javascript:;"
                                    @click.stop="openZsVideo('https://cdn.bosscaigou.com/video_xc.mp4')">
                                    <div class="t_p">
                                        <img src="/images/sp2.jpg" alt="Pig slaughter line">
                                        <i><img src="/images/sp.png" alt="play"></i>
                                    </div>
                                    <div class="w_z">
                                        <span>Pig slaughter line</span>
                                        <h3>Video of Pig Slaughtering Production Line</h3>
                                    </div>
                                </a>
                            </div>
                            <div class="swiper-slide">
                                <a href="javascript:;"
                                    @click.stop="openZsVideo('https://cdn.bosscaigou.com/video_xc.mp4')">
                                    <div class="t_p">
                                        <img src="/images/sp2.jpg" alt="Pig slaughter line">
                                        <i><img src="/images/sp.png" alt="play"></i>
                                    </div>
                                    <div class="w_z">
                                        <span>Pig slaughter line</span>
                                        <h3>Video of Pig Slaughtering Production Line</h3>
                                    </div>
                                </a>
                            </div> -->
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"><i class="iconfont icon-youjiantou"></i></div>
          <div class="swiper-button-next"><i class="iconfont icon-zuojiantou"></i></div>
        </div>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <div class="zs_sp" v-show="videoModalVisible">
      <div class="g_b" @click="closeVideoModal"><i class="iconfont icon-guanbi"></i></div>
      <div class="vd_nr">
        <video width="100%" autoplay controls controlslist="nodownload" webkit-playsinline playsinline x5-playsinline
          x-webkit-airplay="allow" :src="currentVideoUrl"></video>
      </div>
    </div>

  </div>
</template>

<script>
// 引入依赖
import Swiper from 'swiper'
// 引入WOW动画（需先安装：npm install wowjs）
import WOW from 'wowjs'
import 'swiper/css/swiper.css';
import { jumpTo } from '@/utils/myutils';
import { mapState } from 'vuex';
import { randomArticles } from '@/api'

export default {
  name: 'ServiceSupport',
  data() {
    return {
      articlesData:[],
      // 搜索相关
      searchVisible: false,
      searchKeyword: '',
      // 语言下拉框
      languageDropdownVisible: false,
      // 移动端导航
      mobileNavVisible: false,
      // Swiper实例
      serviceProcessSwiper: null,
      videoSwiper: null,
      // 视频弹窗
      videoModalVisible: false,
      currentVideoUrl: '',

      // ========== 页面数据 ==========
      // 选择我们的理由
      chooseUsList: [
        {
          icon: 'ys1.png',
          title: 'Top-tier R&D Strength',
          desc: 'The World’s Exclusive Design & EPC Contractor for Donkey Slaughtering & Refrigeration Projects'
        },
        {
          icon: 'ys2.png',
          title: 'In-depth International Cooperation',
          desc: 'Acquired Germany BANSS, Forging a Powerful Alliance of Advanced Technologies'
        },
        {
          icon: 'ys3.png',
          title: 'Veteran Industry Expert Team',
          desc: 'Rapid Response to Industrial & Market Demands, Leading the Industry’s Technological Trends'
        },
        {
          icon: 'ys4.png',
          title: 'Self-owned Manufacturing Plant',
          desc: 'Strict Quality Control for All Products, Precise Guarantee of Delivery Schedules'
        },
        {
          icon: 'ys5.png',
          title: 'Professional Engineering Team ',
          desc: 'Instant Integrated Technical Support with Efficient Online & On-site Services'
        },
        {
          icon: 'ys6.png',
          title: 'Professional After-sales Team ',
          desc: '7×24 Hour Emergency Rapid Response, Ensuring Worry-free Project Operation'
        }
      ],
      // 服务流程
      serviceProcessList: [
        {
          bgImage: 'lb1.jpg',
          icon: 'lc1.png',
          title: 'Business<br>Communication',
          desc: 'Understand customer needs, clarify material and functional details; provide process flow suggestions for the entire production line.'
        },
        {
          bgImage: 'lb2.jpg',
          icon: 'lc2.png',
          title: 'Design<br>Proposal',
          desc: 'Based on the communication, provide a preliminary plan: including equipment configuration diagram, technical description, budget quotation, etc.'
        },
        {
          bgImage: 'lb3.jpg',
          icon: 'lc3.png',
          title: 'Sign A<br>Contract',
          desc: 'Sign the contract, which clearly specifies technical parameters, delivery time, payment method, and after-sales service terms.'
        },
        {
          bgImage: 'lb4.jpg',
          icon: 'lc4.png',
          title: 'Project<br>Payment',
          desc: 'Offering multi-currency accounts and flexible payment methods to facilitate customer operations.'
        },
        {
          bgImage: 'lb5.jpg',
          icon: 'lc5.png',
          title: 'Product<br>Manufacturing',
          desc: 'Complete manufacturing on standalone machines or production lines within the factory, and test product quality to ensure compliance with technical standards.'
        },
        {
          bgImage: 'lb6.jpg',
          icon: 'lc6.png',
          title: 'Logistics<br>Delivery',
          desc: 'Based on the equipment volume, we provide transportation solutions and guidance on customs clearance documents. We also offer container optimization solutions to reduce transportation costs.'
        },
        {
          bgImage: 'lb7.jpg',
          icon: 'lc7.png',
          title: 'Engineering<br>Installation',
          desc: 'Confirm site conditions with the customer in advance, provide an installation guidebook, dispatch engineers to the site (or provide remote guidance), and coordinate with the local installation team.'
        },
        {
          bgImage: 'lb8.jpg',
          icon: 'lc8.png',
          title: 'Project<br>Delivery',
          desc: 'After the project is accepted and delivered, we will provide a 1-2 year warranty period, 7×24-hour remote technical support, and regular follow-up visits to check on usage.'
        }
      ],
      // 联系方式
      contactInfoList: [
        {
          icon: 'xx1.svg',
          title: '7*24 service hotline:',
          value: '+86 4009-710-788',
          isEmail: false
        },
        {
          icon: 'xx2.svg',
          title: 'Or send an email to:',
          value: 'info@cnhonorgroup.com',
          isEmail: true
        }
      ],
      // 视频列表
      videoList: [
        {
          cover: 'sp2.jpg',
          videoUrl: 'https://cdn.bosscaigou.com/video_xc.mp4',
          category: 'Pig slaughter line',
          title: 'Video of Pig Slaughtering Production Line'
        },
        {
          cover: 'sp2.jpg',
          videoUrl: 'https://cdn.bosscaigou.com/video_xc.mp4',
          category: 'Pig slaughter line',
          title: 'Video of Pig Slaughtering Production Line'
        },
        {
          cover: 'sp2.jpg',
          videoUrl: 'https://cdn.bosscaigou.com/video_xc.mp4',
          category: 'Pig slaughter line',
          title: 'Video of Pig Slaughtering Production Line'
        },
        {
          cover: 'sp2.jpg',
          videoUrl: 'https://cdn.bosscaigou.com/video_xc.mp4',
          category: 'Pig slaughter line',
          title: 'Video of Pig Slaughtering Production Line'
        }
      ]
    }
  },
  mounted() {

    window.scrollTo(0, 0)
    // 初始化WOW动画
    this.initWowAnimation()

    // 获取随机文章
    this.getArticlesData()
    // 初始化Swiper轮播
    this.initSwipers()
    // 滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 销毁Swiper实例
    if (this.serviceProcessSwiper) this.serviceProcessSwiper.destroy(true, true)
    if (this.videoSwiper) this.videoSwiper.destroy(true, true)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    initVideoSwiper() {
      if (this.$refs.videoSwiper) {
        new Swiper(this.$refs.videoSwiper, {
          pagination: {
            el: '.sp_zs .swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: '.sp_zs .swiper-button-next',
            prevEl: '.sp_zs .swiper-button-prev'
          },
          loop: true,
          slidesPerView: "auto",
          breakpoints: {
            650: {
              slidesPerView: 2
            },
            992: {
              slidesPerView: 3
            },
            1280: {
              slidesPerView: 4
            }
          }
        });
      }

      // 原代码中还有swiper-lc的初始化，若页面有该元素可补充：
      // if (this.$refs.lcSwiper) {
      //   new Swiper(this.$refs.lcSwiper, {
      //     loop: false,
      //     speed: 1000,
      //     navigation: {
      //       nextEl: '.lc_zs .swiper-button-next',
      //       prevEl: '.lc_zs .swiper-button-prev'
      //     },
      //     slidesPerView: 1,
      //     spaceBetween: 10,
      //     centeredSlides: true,
      //     breakpoints: {
      //       641: { slidesPerView: 2, spaceBetween: 20 },
      //       993: { slidesPerView: 3, spaceBetween: 20 },
      //       1280: { slidesPerView: 3, spaceBetween: 20 }
      //     }
      //   });
      // }
    },
    async getArticlesData() {
      let data = await randomArticles({
        count: 6
      });
      if (data.code == 200) {
        this.articlesData = data.data;
        this.$nextTick(() => this.initVideoSwiper());
      } else {
        this.$message.error(data.message);
      }
    },
    // ========== 动画初始化 ==========
    initWowAnimation() {
      new WOW.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      }).init()
    },

    // ========== Swiper初始化 ==========
    initSwipers() {
      this.$nextTick(() => {
        // 服务流程轮播
        this.serviceProcessSwiper = new Swiper('.swiper-lc', {
          pagination: {
            el: '.lc_zs .swiper-pagination',
            type: "progressbar",
            clickable: true,
          },
          navigation: {
            nextEl: '.lc_zs .swiper-button-next',
            prevEl: '.lc_zs .swiper-button-prev',
          },
          slidesPerView: "auto",
          breakpoints: {
            650: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            }
          }
        })

        // 视频展示轮播
        this.videoSwiper = new Swiper('.swiper-sp', {
          pagination: {
            el: '.sp_zs .swiper-pagination',
            clickable: true,
          },
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.sp_zs .swiper-button-next',
            prevEl: '.sp_zs .swiper-button-prev',
          },
          loop: true,
          slidesPerView: "auto",
          breakpoints: {
            650: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            }
          }
        })
      })
    },

    // ========== 视频弹窗 ==========
    openVideoModal(url) {
      this.currentVideoUrl = url
      this.videoModalVisible = true
    },

    closeVideoModal() {
      this.videoModalVisible = false
      // 清空视频地址，停止播放
      this.currentVideoUrl = ''
      // 延迟重置，确保视频停止播放
      setTimeout(() => {
        const videoEl = document.querySelector('.zs_sp video')
        if (videoEl) {
          videoEl.pause()
          videoEl.src = ''
        }
      }, 300)
    },

    // ========== 搜索功能 ==========
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.$nextTick(() => {
          const searchInput = document.querySelector('.sc_nr input')
          searchInput?.focus()
        })
      }
    },

    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('Please enter search keywords')
        return
      }
      console.log('Search:', this.searchKeyword)
      this.searchVisible = false
    },

    // ========== 语言下拉框 ==========
    toggleLanguage() {
      this.languageDropdownVisible = !this.languageDropdownVisible
    },

    // ========== 移动端导航 ==========
    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
      document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
    },

    // ========== 滚动相关 ==========
    handleScroll() {
      // 可添加滚动时的样式变化逻辑
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped></style>